<template>
    <div class="layout">
      <div style="text-align:right;padding-right:20px;"><Button style="background:#FFF;color:#000;border-color:#e0e0e0;" type="primary" @click="goBack">{{ $t('common.back') }}</Button></div>
      <iframe class="formInstance" id="formInstance" :src="src" style="height: 100vh;" frameborder="0"></iframe>
    </div>
</template>

<script>
export default {
  name: 'UrlInstanceView',
  // props: ['src'],
  data () {
    return {
      src: ''
    };
  },
  watch: {
    '$route' (newVal) {
      if (newVal.path.indexOf('UrlInstanceView') > -1) {
        let win = window.open('//mplmvendor.midea.com');
        win.close();
        this.reload();
      }
    }
  },
  methods: {
    reload () {
        let href = location.href;
        let url = this.isPro() ? '//mplmvendor.midea.com/#' : '//mplmvendoruat.midea.com/#';
        // let link = '';
        let lang = {
            'zh-CN': 'zh_CN',
            'en-US': 'en_US'
        }[this.$i18n.locale];
        let urls = [
          '',
          '/system_notification?targetRoute=system_notification&name=%E7%B3%BB%E7%BB%9F%E9%80%9A%E7%9F%A5',
          '/sample_confirmation?targetRoute=sample_confirmation&name=%E6%A0%B7%E5%93%81%E7%A1%AE%E8%AE%A4%E5%8D%95',
          '/sample_confirmation_status_adjust?targetRoute=sample_confirmation_status_adjust&name=%E6%A0%B7%E5%93%81%E7%A1%AE%E8%AE%A4%E7%8A%B6%E6%80%81%E8%B0%83%E6%95%B4',
          '/sample_delivery_application?targetRoute=sample_delivery_application&name=%E9%80%81%E6%A0%B7%E7%94%B3%E8%AF%B7%E5%8D%95',
          '/sample_supplier_dataInput?targetRoute=sample_supplier_dataInput&name=%E9%80%81%E6%A0%B7%E4%BE%9B%E6%96%B9%E8%B5%84%E6%96%99%E5%BD%95%E5%85%A5',
          '/part_commission_test?targetRoute=part_commission_test&name=%E9%9B%B6%E9%83%A8%E4%BB%B6%E5%A7%94%E6%89%98%E6%B5%8B%E8%AF%95%E5%8D%95',
          '/test_report?targetRoute=test_report&name=%E6%B5%8B%E8%AF%95%E6%8A%A5%E5%91%8A',
          '/offset_film_information?targetRoute=offset_film_information&name=%E8%83%B6%E7%89%88%E8%8F%B2%E6%9E%97%E8%B5%84%E6%96%99',
          '/jiaoban_info?targetRoute=jiaoban_info&name=%E8%83%B6%E7%89%88%E8%8F%B2%E6%9E%97',
          '/problems_tobe_rectified?targetRoute=problems_tobe_rectified&name=%E5%BE%85%E6%95%B4%E6%94%B9%E9%97%AE%E9%A2%98%E9%A1%B9',
          '/document_management?targetRoute=document_management&name=%E6%96%87%E6%A1%A3%E7%AE%A1%E7%90%86%E5%8A%9F%E8%83%BD',
          '/drawing_standard_search?targetRoute=drawing_standard_search&name=%E5%9B%BE%E7%BA%B8%23%E4%BC%81%E6%A0%87%E6%9F%A5%E8%AF%A2',
          '/mco_change?targetRoute=mco_change&name=MCO',
          '/ecr_change?targetRoute=ecr_change&name=ECR',
          '/eco_change?targetRoute=eco_change&name=ECO',
          '/supplier_confirmation?targetRoute=supplier_confirmation&name=%E4%BE%9B%E5%BA%94%E5%95%86%E7%A1%AE%E8%AE%A4',
          '/handboard_change_application?targetRoute=handboard_change_application&name=%E6%89%8B%E6%9D%BF%E5%8F%98%E6%9B%B4%E7%94%B3%E8%AF%B7',
          '/handboard_status_search?targetRoute=handboard_status_search&name=%E6%89%8B%E6%9D%BF%E7%8A%B6%E6%80%81%E6%9F%A5%E8%AF%A2',
          '/handboard_reconfirmation?targetRoute=handboard_reconfirmation&name=%E9%A9%B3%E5%9B%9E%E5%86%8D%E7%A1%AE%E8%AE%A4%E6%89%8B%E6%9D%BF',
          '/supplier_delivery_list?targetRoute=supplier_delivery_list&name=%E4%BE%9B%E5%BA%94%E5%95%86%E9%80%81%E8%B4%A7%E6%B8%85%E5%8D%95',
          '/uploading_CertInfo?targetRoute=uploading_CertInfo&name=待上传证书',
          '/uploaded_CertInfo?targetRoute=uploaded_CertInfo&name=已上传证书的认证',
          '/view_DrawingInfo?targetRoute=view_DrawingInfo&name=集采图纸查询',
          '/auditing_management?targetRoute=auditing_management&name=%E5%AE%A1%E8%AE%A1%E7%AE%A1%E7%90%86',
          '/long_cycle_inspection_project_submission?targetRoute=long_cycle_inspection_project_submission&name=%E9%95%BF%E5%91%A8%E6%9C%9F%E6%A3%80%E6%B5%8B%E9%A1%B9%E7%9B%AE%E6%8F%90%E4%BA%A4'
        ];
        // if (href.indexOf('/1') > -1) { // 系统通知
        //   link = 'system_notification?targetRoute=system_notification&name=%E7%B3%BB%E7%BB%9F%E9%80%9A%E7%9F%A5';
        // } else if (href.indexOf('/2') > -1) { // 样品确认单
        //   link = 'sample_confirmation?targetRoute=sample_confirmation&name=%E6%A0%B7%E5%93%81%E7%A1%AE%E8%AE%A4%E5%8D%95';
        // } else if (href.indexOf('/3') > -1) { // 样品确认状态调整
        //   link = 'sample_confirmation_status_adjust?targetRoute=sample_confirmation_status_adjust&name=%E6%A0%B7%E5%93%81%E7%A1%AE%E8%AE%A4%E7%8A%B6%E6%80%81%E8%B0%83%E6%95%B4';
        // } else if ()
        this.src = `${url}${urls[href.split('/')[href.split('/').length - 1]]}&onlyContent=1&lang=${lang}`;
    },
    goBack () {
    //   let src = this.src;
    //   this.src = '';
    //   setTimeout(() => {
    //     this.src = src;
    //   }, 50);
        window.history.go(-1);
    }
  },
  mounted () {
    this.reload();
  }
};
</script>

<style lang="less" scoped>
    .layout {
      height:100%;
      width: 100%;
      background: #f2f2f2;
    }
    iframe{
      height:100%;
      width: 100%;
  }
</style>
